<template>
  <div class="display_flex bot_nav">
    <div class="display_flex l_list">
      <div class="l_item">
        <div class="pointer" @click="$router.push('/mineData/aboutUs')">关于我们</div>
        <div class="pointer" @click="$router.push('/mineData/termService')">服务条款</div>
      </div>
<!--      <div class="l_item">-->
<!--        <div>服务条款</div>-->
<!--      </div>-->
<!--      <div class="l_item">-->
<!--        <div>APP下载</div>-->
<!--        <div>场馆入驻</div>-->
<!--        <div>常见问题</div>-->
<!--      </div>-->
      <div class="l_item">
        <div>主办：辽宁省体育局主办</div>
        <div>承办：辽宁省体育场馆服务中心</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="display_flex r_img">
      <div class="i_item">
        <img alt="" src="../assets/image/gzh1.png">
        <div>微信公众号</div>
      </div>
      <div class="i_item" style="margin: 0 40px">
        <img alt="" src="../assets/image/gzh2.png">
        <div>微信公众号</div>
      </div>
      <div class="i_item">
        <img alt="" src="../assets/image/app.png">
        <div>APP下载</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "botNav"
}
</script>

<style lang="less" scoped>
.bot_nav {
  height: 337px;
  padding: 60px 0;
  background: url("../assets/image/bot_img.png") no-repeat;
  background-size: cover;
  color: #FFFFFF;
  font-size: 16px;

  .l_list {
    width: 50%;
    justify-content: center;
    white-space: nowrap;

    .l_item {
      margin-right: 10%;

      &:last-child {
        margin-right: 0;
      }

      div {
        margin-bottom: 36px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .pointer {
      cursor: pointer;
    }
  }

  .line {
    width: 1px;
    height: 179px;
    background: #FFFFFF;
  }

  .r_img {
    width: 50%;
    justify-content: center;
    text-align: center;

    .i_item {
      width: 20%;
      max-width: 172px;

      img {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
